import { useParams } from "react-router-dom"

import {
  defaultDigestConfig,
  getdeterministicNodeId,
} from "@costory/shared/utils/digest"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { DigestForm } from "@costory/front/pages/DigestV2/DigestForm"
import {
  useEditDigestMutation,
  useGetDigestConfigQuery,
  useQueryOpenDigest,
} from "@costory/front/queries/digest"

export function EditDigest() {
  const { digestId } = useParams<{ digestId: string }>()
  const mutation = useEditDigestMutation(digestId!)
  const query = useQueryOpenDigest(digestId!)
  const digestConfigQuery = useGetDigestConfigQuery(digestId)
  const costColumn = digestConfigQuery.data?.costColumn || "cost"
  const exclusionWhereClause =
    digestConfigQuery.data?.whereClause || defaultDigestConfig.whereClause
  return (
    <QueryWrapper query={digestConfigQuery}>
      {({ data: digestConfig }) => (
        <QueryWrapper query={query}>
          {({ data }) => {
            const processedDigestData = {
              ...data,
              items: data.items.map((item) => {
                const deterministicId = getdeterministicNodeId(item.position)
                const isOthersNode =
                  item.direction === "Others" || item.id.includes("others-")

                const parentItem = item.parentId
                  ? data.items.find((p) => p.id === item.parentId)
                  : null
                const parentDeterministicId = parentItem
                  ? getdeterministicNodeId(parentItem.position)
                  : item.parentId

                return {
                  ...item,
                  id: isOthersNode ? item.id : deterministicId,
                  parentId: parentDeterministicId,
                }
              }),
            }
            return (
              <DigestForm
                initialValues={processedDigestData}
                onSave={(d) => mutation.mutateAsync(d)}
                costColumn={costColumn}
                exclusionWhereClause={exclusionWhereClause}
                isEditMode={true}
                digestConfig={digestConfig}
              />
            )
          }}
        </QueryWrapper>
      )}
    </QueryWrapper>
  )
}
